/**
 * Spec 10.2.1 — App Shell route root. Reuses the console AuthGuard for session +
 * workspace membership, then renders the product shell chrome (which additionally
 * gates on ledger_enabled). A sibling of the console's V3Layout, so the product
 * surface has its own chrome and the maker surface stays untouched.
 */
import { AuthGuard } from "../../../lib/components/AuthGuard";
import { AppShellLayout } from "./AppShellLayout";
import { CoPanelProvider } from "../../components/collab/co-panel-context";
import { ConversationHostProvider } from "../../components/collab/conversation-host";
import { StageHeadProvider } from "./stage-head";
import { CommandPaletteProvider } from "../../components/command-palette/CommandPaletteContext";

export function AppShellRoot() {
  return (
    <AuthGuard>
      {/* №22.3 (D-CH0) — the docked chat panel's state, mounted once above the
          shell so it (and the panel) survive all `/app` navigation (D-CH3). */}
      <CoPanelProvider>
        {/* №29 (S1) — the conversation's stable host, also above the shell: the rail
            and the chat subject's stage take turns holding ONE conversation, and the
            host has to outlive every route for that to be true (D-SS2). */}
        <ConversationHostProvider>
          {/* №29 (S2) — what the SUBJECT contributes to the stage head: its working
              title, its live state, its own verbs. Above the shell because the head
              and the routed outlet are siblings inside it. */}
          <StageHeadProvider>
            {/* №44 — the palette's open/mode state. The PROVIDER is the console's,
                unchanged: it is 70 lines of pure state with no console reference in
                it. What could not be reused is the palette itself — its command
                sources call console-only providers, its destinations are console
                routes, and it is styled in the console's token vocabulary. See
                `AppCommandPalette.tsx`. */}
            <CommandPaletteProvider>
              <AppShellLayout />
            </CommandPaletteProvider>
          </StageHeadProvider>
        </ConversationHostProvider>
      </CoPanelProvider>
    </AuthGuard>
  );
}
